import React, { useEffect } from 'react';

import _ from 'lodash';
import { Div } from 'nexcomponent-ui';
import { useSelector } from 'react-redux';

import {
  productCategoryBreadCrumb,
} from '../../../../Enum/Breadcrumb/ProductCategoryBreadcrumb';
import { MAPPING_CODE } from '../../../../Enum/MappingCode/MappingCode';
import {
  ROUTER_CONSTANT,
} from '../../../../Enum/RouterConstant/RouterConstant';
import {
  fetchDataApprovalProductCategory,
  fetchProductCategoryMappingForm,
} from '../../../../Fetch/FetchData/ProductCategoryData';
import { mappingFormPageStateGroup } from '../../../../Store/StateGroup';
import CancelOverwrite
  from '../../../Organisms/Button/CancelOverwrite/CancelOverwrite';
import MappingForm
  from '../../../Organisms/Form/MappingForm/MappingForm/MappingForm';
import HeaderPageMapping
  from '../../../Organisms/Header/HeaderPageMapping/HeaderPageMapping';
import ModalMapping from '../../../Organisms/Modal/ModalMapping/ModalMapping';

const ProductCategoryMappingPage = props => {
  const [, list, , mappingForm] = useSelector(mappingFormPageStateGroup);

  useEffect(() => {
    if (_.has(props.location.state, "data")) {
      const first = _.first(list);
      fetchProductCategoryMappingForm(
        props.validToken(),
        props.dispatch,
        "product_category_id",
        first.id,
        props.location.state.data.product_category_id,
        list,
        props.notify,
        () => props.navigate(ROUTER_CONSTANT.PRODUCT_CATEGORY.MAPPING)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, props.location.state, props.dispatch, props.validToken]);
  return (
    <Div>
      <ModalMapping
        t={props.t}
        dispatch={props.dispatch}
        navigate={props.navigate}
        listNavigate={ROUTER_CONSTANT.PRODUCT_CATEGORY.LIST}
        approveFuc={(data, mappingList, mappingCount) =>
          fetchDataApprovalProductCategory(
            props.validToken(),
            data,
            mappingList,
            mappingCount,
            props.notify,
            props.dispatch
          )
        }
        uniqueKey="product_category_id"
        nextMapping={(uniqueKey, newId, existId, mappingList) =>
          fetchProductCategoryMappingForm(
            props.validToken(),
            props.dispatch,
            uniqueKey,
            newId,
            existId,
            mappingList,
            props.notify,
            () => props.navigate(ROUTER_CONSTANT.PRODUCT_CATEGORY.MAPPING)
          )
        }
      />

      <HeaderPageMapping
        title={props.t("PRODUCT_CATEGORY:TITLE")}
        listBreadcrumb={productCategoryBreadCrumb(props.t)}
        defaultBreadcrumb={props.t("PRODUCT_CATEGORY:MAPPING.TITLE")}
        to={ROUTER_CONSTANT.PRODUCT_CATEGORY.LIST}
      />
      <MappingForm
        t={props.t}
        validToken={props.validToken}
        dispatch={props.dispatch}
        navigate={props.navigate}
        idKey="product_category_id"
        mappingCode={MAPPING_CODE.PRODUCT_CATEGORY}
        mappingForm={mappingForm}
      />
      <CancelOverwrite
        t={props.t}
        dispatch={props.dispatch}
        navigate={props.navigate}
        idKey="product_category_id"
        mappingForm={mappingForm}
        mappingCode={MAPPING_CODE.PRODUCT_CATEGORY}
      />
    </Div>
  );
};

export default ProductCategoryMappingPage;
